// Android app (APK) download configuration.
//
// By default the button points at our own backend, which streams the APK from
// wherever it is stored (see backend/routes/appDownload.js). That indirection is
// deliberate: Google Drive shows browsers an "is executable and may harm your
// computer" interstitial for .apk files, so linking learners straight at Drive
// sends them off our domain and into a scary-looking warning. Proxying keeps the
// download on our domain, warning-free, and lets us change storage hosts without
// shipping a new web build.
//
// Set REACT_APP_ANDROID_APK_URL only to override that (e.g. to point at a CDN
// directly). Note that any cross-origin host controls the saved filename and may
// interpose its own interstitial.
const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:5001/api';

export const ANDROID_APK_URL =
  process.env.REACT_APP_ANDROID_APK_URL || `${API_BASE.replace(/\/+$/, '')}/app/android`;

// True when the APK is served from this site, so the browser will honor the
// `download` attribute (it is ignored cross-origin) and no new tab is needed.
// The proxy sets its own Content-Disposition filename, so the attribute is not
// needed there anyway.
export const IS_APK_SAME_ORIGIN = /^\/(?!\/)/.test(ANDROID_APK_URL);

// Filename hint for the browser's download prompt (honored for same-origin URLs).
export const ANDROID_APK_FILENAME = 'lingobooth-android.apk';

// Lightweight Android detection (for tailoring copy only — not security).
export function isAndroidDevice() {
  if (typeof navigator === 'undefined') return false;
  return /android/i.test(navigator.userAgent || '');
}
